/* eslint-disable eqeqeq */
/* eslint-disable indent */
import { axios, } from '@/common'

export default {
  namespaced: true,
  state: {
    curClubId: '',
    clubList: [],
    matchMap: {},

    clubNavCompScrollTop: 0,//组件保存状态用 src/view/eSport/comps/clubNav
  },
  getters: {
    curClub: (state) => {
      let club = state.clubList.find(c => c.id == state.curClubId)
      if (club) {
        return {
          ...{
            achievement: "",
            introduce: "",
            clubTwitter: "",
            joinTime: "",
          },
          ...club,
          matchs: (club.matchs || []).map(item => state.matchMap[item.id] ? { ...item, matchInfo: state.matchMap[item.id] } : null).filter(item => !!item)
        }
      }
    }
    /* getChannelParamList: (state, getters) => (id) => {
      return state.channelList.find(item => item.id === id) || null;
    },
    getParamErrorList: (state, getters, rootState) => {
      let errorList = [];
      for (let channelCode of Object.keys(getters.getParamErrorMap)) {
        let channel = getters.getParamErrorMap[channelCode];
        if (channel.error) {
          errorList.push({
            name: channel.name,
            code: channelCode,
            id: channel.id,
            level: 1
          });
        }
        for (let subChannelCode of Object.keys(channel.subChannel)) {
          let subChannel = channel.subChannel[subChannelCode];
          if (subChannel.error) {
            errorList.push({
              name: subChannel.name,
              code: subChannelCode,
              id: subChannel.id,
              level: 2,
              mainChannel: {
                name: channel.name,
                code: channelCode,
                id: channel.id
              }
            });
          }
        }
      }
      return errorList;
    } */
  },
  mutations: {
    switchCurClub(state, id) {
      let club = state.clubList.find(c => c.id == id)
      if (club) {
        state.curClubId = id;
      } else if (!state.curClubId && state.clubList[0]) {
        state.curClubId = state.clubList[0].id || ''
      }
    },
    updateClubList(state, list) {
      state.clubList = list;
    },
    updateClub(state, club) {
      if (club.matchs) {
        for (let match of club.matchs) {
          state.matchMap[match.id] = match.matchInfo;
          delete match.matchInfo
        }
      }
      state.clubList = state.clubList.map(item => {
        if (item.id == club.id) {
          return club
        } else {
          return item
        }
      })

    },
    updateMatch(state, match) {
      state.matchMap[match.id] = match
    },
    setClubNavCompScrollTop(state, num) {
      state.clubNavCompScrollTop = num
    }
  },
  actions: {
    async getClubList({ commit, state, rootState, dispatch, getters }) {
      let result = await axios.get(`/api/clubList/`);
      if (result.status == 200) {
        if (result.data) {
          let data = result.data;
          let { firstClub, list } = data;

          commit('updateClubList', list)
          commit('updateClub', firstClub)
          commit('switchCurClub', firstClub.id)
        }
      }
    },
    async getClubListWhileNeed({ commit, state, rootState, dispatch, getters }) {
      if (state.clubList && !state.clubList.length) {
        dispatch('getClubList')
      }
    },
    async getClub({ commit, state, rootState, dispatch, getters }, id) {
      let result = await axios.get(`/api/club/${id}`);
      if (result.status == 200) {
        if (result.data) {
          let data = result.data;

          commit('updateClub', data)
          commit('switchCurClub', id)
        }
      }
    },
    async switchCurClub({ commit, state, rootState, dispatch, getters }, id) {
      if (state.curClubId == id) {
        return
      }
      let club = state.clubList.find(c => c.id == id)
      if (club && club.players) {
        commit('switchCurClub', id)
        return
      }
      if (!club) {
        await dispatch('getClubList')
      }
      dispatch('getClub', id)

    }
  }
};
